import styled, { keyframes } from "styled-components";

import { DAVYS_GREY_800 } from "../colors";
import { Body2 } from "../Headings";

const ThinkingText = styled(Body2)`
  color: ${DAVYS_GREY_800};
  font-weight: 500;
  font-size: 0.875rem;
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;

const bounce = keyframes`
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.5;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
`;

const Dot = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: ${DAVYS_GREY_800};
  display: inline-block;
  animation: ${bounce} 1.2s infinite;
  animation-delay: ${({ delay }) => delay};
`;

const DotsWrapper = styled.span`
  display: inline-flex;
  gap: 3px;
  margin-left: 4px;
`;

const AiChatThinkingBubble = () => (
  <ThinkingText>
    Thinking
    <DotsWrapper>
      <Dot delay="0s" />
      <Dot delay="0.2s" />
      <Dot delay="0.4s" />
    </DotsWrapper>
  </ThinkingText>
);

export default AiChatThinkingBubble;
